import { useWindowDimensions, Platform } from 'react-native';

export const BREAKPOINTS = {
  mobile: 0,
  desktop: 768, // iPad portrait and up get the desktop layout (matches the design kits)
} as const;

export const useResponsive = () => {
  const { width, height } = useWindowDimensions();
  const isWeb = Platform.OS === 'web';
  const isDesktop = isWeb && width >= BREAKPOINTS.desktop;
  const isMobile = !isDesktop;

  return { isDesktop, isMobile, isWeb, width, height };
};
